import { Component } from "@angular/core";
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from "@angular/forms";
import { RegistroUsuarioServiceService } from "../../../../../pages/account/registro-afiliado/services/registro-usuario-service.service";
import { ToastrService } from "ngx-toastr";
import { Router } from "@angular/router";
import Swal from "sweetalert2";
import { OrderService } from "../../../../../shared/services/order.service";
import { ProductService } from "src/app/shared/services/product.service";
import { GoogleAnalyticsService } from "../../../../../shared/services/google-analytics.service";


@Component({
 // imports:[    DxiValidationRuleComponent,DxValidatorComponent],
  selector: 'app-modal-register',
  templateUrl: './modal-register.component.html',
  styleUrls: ['./modal-register.component.scss'],
  //standalone:true
})
export class ModalRegisterComponent {
  minCaracteres = false;
  maxCaracteres = false;
  hasNumber = false;
  hasMinus = false;
  hasMayus = false;
  espCaracter = false;
  public registrarUsuarioForm: FormGroup;
  min: Date = new Date(1900, 0, 1);
  max: Date = new Date();
  public fechaNacimiento;
  public hidePass: boolean = true;
  public hideConfirm: boolean = true;
  public mensajes = {
    nombre: "",
    apellidoPaterno: "",
    apellidoMaterno: "",
    correo: "",
    password: "",
    confirmPassword: "",
    permisos: "",
  };
  OrderService: any;

  constructor(
    private service: RegistroUsuarioServiceService,
    private orderService: OrderService,
    private prodService: ProductService,
    private fb: FormBuilder,
    private toastr: ToastrService,
    private analytics: GoogleAnalyticsService,
    private router: Router
  ) {}

  ngOnInit() {
    this.max.setFullYear(this.max.getFullYear() - 18);
    this.initForm();

    this.registrarUsuarioForm.get('YaEsCliente')?.valueChanges.subscribe(value => {
      if (!value) {
        // Si YaEsCliente es false, limpiamos ambos campos
        this.registrarUsuarioForm.patchValue({
          phoneNumber: '',
          NumeroCliente: ''
        });
      }
    });
  }
 
  get diffInDay() {
    return `${Math.floor(
      Math.abs(
        (new Date().getTime() - this.fechaNacimiento.getTime()) /
          (24 * 60 * 60 * 1000)
      )
    )} days`;
  }

  initForm() {
    const correo = this.orderService.getSharedMail();
    this.OrderService;
    this.registrarUsuarioForm = this.fb.group({
      YaEsCliente: [false],
      Telefono: [''],
      phoneNumber:  new FormControl("", [Validators.required]),
      NumeroCliente: [''],
      nombre: [],
      apellidoPaterno: [],
      apellidoMaterno: [],
      correo: [correo ? correo : "", [Validators.pattern(/^\S+@\S+\.\S+$/)]],
      fechaNacimiento: new FormControl("", [Validators.required]),
      passwordGroup: this.fb.group(
        {
          password: [
            "",
            Validators.compose([
              Validators.required,
              Validators.minLength(6),
              Validators.maxLength(16),
              Validators.pattern(
                "^(?=.*\\d)(?=.*[A-Z])(?=.*[a-z])(?=.*\\W).{6,16}$"
              ),
            ]),
          ],
          confirmPassword: [
            "",
            Validators.compose([
              Validators.required,
              Validators.minLength(6),
              Validators.maxLength(16),
              Validators.pattern(
                "^(?=.*\\d)(?=.*[A-Z])(?=.*[a-z])(?=.*\\W).{6,16}$"
              ),
            ]),
          ],
        },
        { validator: passwordMatcher }
      ),
    });
    this.registrarUsuarioForm.valueChanges.subscribe(() => {
      this.setMessage(
        this.registrarUsuarioForm.get("passwordGroup.password"),
        "password",
        "contraseña"
      );
    });
    
    this.registrarUsuarioForm.get('Telefono')?.setValidators([this.telefonoNumeroClienteValidator()]);
    this.registrarUsuarioForm.get('NumeroCliente')?.setValidators([this.telefonoNumeroClienteValidator()]);

    this.registrarUsuarioForm.updateValueAndValidity();

  }

  
  
    telefonoNumeroClienteValidator(): ValidatorFn {
      return (control: AbstractControl): ValidationErrors | null => {
        const form = control.parent; // Accedemos al formulario completo.
        if (!form) return null;
  
        const telefono = form.get('Telefono')?.value;
        const numeroCliente = form.get('NumeroCliente')?.value;
        const yaEsCliente = form.get('YaEsCliente')?.value;
  
        // Si es cliente, al menos uno de los dos campos debe ser requerido
        if (yaEsCliente) {
          if (!telefono && !numeroCliente) {
            return { telefonoNumeroRequerido: true }; // Error si ninguno está lleno
          }
        }
  
        return null; // Sin errores
      };
    }

  registrarUsuario() {
    const esCliente = this.registrarUsuarioForm.get('YaEsCliente')?.value;
    const telefono = this.registrarUsuarioForm.get('Telefono')?.value;
    const numeroCliente = this.registrarUsuarioForm.get('NumeroCliente')?.value;

    if (esCliente && !telefono && !numeroCliente) {
      this.toastr.error('Ingrese número de teléfono o cliente.');
      window.scrollTo({
        top: 0,
        behavior: "smooth", // Para un desplazamiento suave
      });
      return; // Evitamos que el servicio se ejecute si no se cumplen los requisitos
    }

    this.registrarUsuarioForm.patchValue({
      fechaNacimiento: this.fechaNacimiento,
    });
    var usuario = { ...this.registrarUsuarioForm.value };
    usuario = {
      ...usuario,
      ...this.registrarUsuarioForm.get("passwordGroup").value,
    };
    this.service.registrarUsuario(usuario).subscribe(
      (result: any) => {
        this.service.obtenerIdUserRegistro(result.idUser);

        this.analytics.sendEvent('sign_up', {
          idEvento: 2,
          method: 'email', // Puedes cambiarlo a 'google', 'facebook', etc.
          userName: usuario.correo // Opcional, si tienes un identificador del usuario registrado
        });
        this.service.obtenerCorreo(this.registrarUsuarioForm.get('correo').value);
        this.service.cerrarModal(true);
        this.service.cerrarModalLogin(false);
        this.service.cerrarModalRegister(false);
        this.service.vieneDeCheckout(true);
        this.registrarUsuarioForm.reset();
        this.toastr.success("Registro Correcto");
        this.prodService.$modalRegister.emit({
          login: false,
          register: false,
          codigo: true,
        });
      },
      (err) => {
        if(err.error.errors) {
          this.toastr.error('Ingresa correctamente los datos en el formulario.');
        } else {
          this.analytics.sendEvent('error_sign_up', {
            idEvento: 11,
            method: 'email',  // Método de autenticación usado
            reason: 'err.error', // Mensaje del error
            userName: usuario.correo // Opcional, si tienes un identificador del usuario registrado
          });
          this.toastr.error(err.error);
        }
        window.scrollTo({
          top: 0,
          behavior: "smooth", // Para un desplazamiento suave
        });
      }
    );
}

  setMessage(c: AbstractControl, campo: string, campoVisual: string): void {
    this.mensajes[campo] = "";

    if ((c.touched || c.dirty) && c.errors) {
      // Check each error key and display the first one that fails
      for (const key of Object.keys(c.errors)) {
        const errorMessage = this.generateMessage(c, key, campoVisual);
        if (errorMessage) {
          this.mensajes[campo] = errorMessage;
          break; // Stop checking once the first error is found
        }
      }
    }
  }

  generateMessage(
    c: AbstractControl,
    key: string,
    campoVisual: string
  ): string {
    switch (key) {
      case "required":
        return `El campo ${campoVisual} es requerido`;
      case "match":
        return "Las contraseñas no coinciden";
      case "email":
        return "Ingrese un correo válido";
      case "minlength":
        return `La ${campoVisual} debe contener más de ${c.errors[key].requiredLength} caracteres`;
      case "maxlength":
        return `La ${campoVisual} debe contener menos de ${c.errors[key].requiredLength} caracteres`;
      case "pattern":
        return "La contraseña debe tener al menos un dígito, una minúscula, una mayúscula y un caracter no alfanumérico.";
      default:
        return `El campo ${campoVisual} es inválido`;
    }
  }

  togglePassword(key: String) {
    if (key === "password") {
      this.hidePass = !this.hidePass;
    } else {
      this.hideConfirm = !this.hideConfirm;
    }
  }

  onPasswordInput(event: Event): void {
    const value = (event.target as HTMLInputElement).value;
    this.minCaracteres = value.length >= 6;
    this.maxCaracteres = value.length <= 16;
    this.hasNumber = /\d/.test(value);
    this.hasMinus = /[a-z]/.test(value);
    this.hasMayus = /[A-Z]/.test(value);
    this.espCaracter = /[^\w\d]/.test(value);
  }

  changeModal(modalLogin: boolean, modalRegister: boolean) {
    this.prodService.$modalRegister.emit({
      login: modalLogin,
      register: modalRegister,
    });
  }

  closeModal() {
    this.service.cerrarModalRegister(false);
  }

  soloNumeros(event: any): void {
    const input = event.target as HTMLInputElement;
    const soloNumeros = input.value.replace(/[^0-9]/g, "");
    this.registrarUsuarioForm.patchValue({ phoneNumber: soloNumeros });
  }

  soloNumeros2(event: any): void {
    const input = event.target as HTMLInputElement;
    const soloNumeros = input.value.replace(/[^0-9]/g, "");
    this.registrarUsuarioForm.patchValue({ Telefono: soloNumeros });
  }
  
}

function passwordMatcher(c: AbstractControl): { [key: string]: boolean } | null {
	const passwordControl = c.get('password');
	const confirmPasswordControl = c.get('confirmPassword');

	if (passwordControl.pristine || confirmPasswordControl.pristine) {
		confirmPasswordControl.setErrors(null);
		return null;
	}

	if (passwordControl.value === confirmPasswordControl.value) {
		confirmPasswordControl.setErrors(null);
		return null;
	}

	confirmPasswordControl.setErrors({ 'match': true });

	return { 'match': true };


}
